import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=2ae0c2a2&scoped=true"
import script from "./app-aside.vue?vue&type=script&lang=js"
export * from "./app-aside.vue?vue&type=script&lang=js"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=2ae0c2a2&prod&lang=scss&scoped=true"
import style1 from "./app-aside.vue?vue&type=style&index=1&id=2ae0c2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0c2a2",
  null
  
)

export default component.exports